module.exports = __webpack_public_path__ + "static/media/lineBased.be261127.svg";